// prettier-ignore
export const LoadingActionTypes = {
  SET_REGION_DATA_LOADING: 'SET_REGION_DATA_LOADING',
};
